<template>
  <div class="body-view" style="background-image: url('static/img/body-bg.png');">
    <div class="top">
      <div class="back" @click="back">
        <div>< 返回</div>
      </div>
      明白卡 —— 险种列表
    </div>
    <div class="list" >
      <img src="static/img/logo-green.png" class="logo" alt />
      <div class="item" v-for="(item,index) in listData" :key="index" @click="toDetail(item)">
        <div class="item-name">{{ item.riskcname }}</div>
      </div>
      <div style="width: 100%;height: 50px"></div>
    </div>
  </div>
</template>
<script type="application/javascript">
var obj = require("@/api/api.js");
export default {
  data(){
    return{
      listData:[]
    }
  },
  created() {
    this.queryList()
  },
  methods:{
    queryList(){
      let param = {
        "riskType":this.$route.query.type
      }
      let hubeiQueryRiskInfo = obj.hubeiQueryRiskInfo;
      this.$http
        .post(hubeiQueryRiskInfo, param)
        .then((res) => {
          console.log(res.data)
          if(res.data.rtnCode=='0000'){
            this.listData = res.data.riskInfoList
          }else{
            console.log('列表获取失败，'+ res.data.rtnMsg)
          }
        }).catch(err=>{
          console.log(err)
      })
    },
    toDetail(row){
      this.$router.push({
        path: "/knowCardDetail",
        query: {
          riskcode: row.riskcode,
          riskname:row.riskcname
        }
      })
    },
    back(){
      this.$router.go(-1)
    }
  },
}
</script>
<style scoped lang="scss">
  body{
    background-color: #f6fff8 !important;
  }
  .body-view{
    width: 100%;
    //min-height: 100vh;
    //height: auto;
    height: 100vh;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: bottom;
    background-color:  #f6fff8 ;
    //background-color: #e1ffe7 !important;
    .top{
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      text-align: center;
      border-bottom: #e5b1fb 1px solid;
      position: fixed;
      top: 0;
      z-index: 100;
      background-color: #f6fff8;
      .back{
        position: absolute;
        padding-left: 5vw;
        padding-right: 5vw;
        color: #00a80d;
      }

    }
    .list{
      width: 100%;
      //min-height: calc(100vh - 50px);
      //display: table;
      //height: auto;
      height: calc(100vh - 50px);
      overflow: scroll;
      .logo{
        width: 70vw;
        margin-left: 15vw;
        margin-top: -20vw;
      }
      .item{
        width: 90vw;
        height: auto;
        padding: 2vw 4vw;
        border-left: #3bd800 4px solid;
        background: #FFFFFF;
        //border: #2B9C00 1px solid;
        margin: 5vw;
        position: relative;

        .item-name{
          font-size: 4.5vw;
          color:#248500 ;
          text-decoration: underline;
          text-underline-offset: 5px;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/KnowCard/knowlist.vue